import { Component, Optional } from '@angular/core';
import { DynamicFormService } from '@ntap/common';
import {
  BackendUploadService,
  Item,
  ItemProvider,
  ItemView,
  ItemViewProviderDirective,
  NotificationService,
  NtapGlobalConstants,
  Util,
  ViewWindow
} from '@ntap/core';
import { PrimeNGButtonSaveCloseItemActionComponent } from '@ntap/primeng';
import { map, Observable, withLatestFrom } from 'rxjs';

import { ParentItemProviderService } from '@app/shared';

export class ChildItemProviderWrapper extends ItemProvider {
  private nextItem$: Observable<[Item, Item]>;

  private getItemCombo$(): Observable<[Item, Item]> {
    if (this.parentItemProvider) {
      return this.itemProvider.item$.pipe(
        withLatestFrom(this.parentItemProvider.parentItem$)
      );
    } else {
      return this.itemProvider.item$.pipe(
        map((item) => [item, (item as any)[NtapGlobalConstants.ATTR_$parent]])
      );
    }
  }

  constructor(
    protected itemProvider: ItemProvider,
    protected parentItemProvider: ParentItemProviderService
  ) {
    super();
    this.initNextItem();
  }

  private initNextItem() {
    const itemCombo$: Observable<[Item, Item]> = this.getItemCombo$();
    this.nextItem$ = itemCombo$.pipe(
      map(([item, parentItem]: [item: any, parentItem: any]) => {
        const parentType =
          parentItem[NtapGlobalConstants.ATTR_$itemType] ||
          parentItem[NtapGlobalConstants.ATTR_$mainType];
        const parentIdValue = {
          $parentId:
            parentItem[
              Util.getFullAttrName(parentType, NtapGlobalConstants.ATTR_id)
            ],
          $parentType: parentType
        };
        return Object.assign({}, item, parentIdValue);
      })
    );
  }

  override updateItem(item: object) {
    this.itemProvider.updateItem(item);
  }
  override refresh(): void {
    this.itemProvider.refresh();
  }

  override get item$(): Observable<Item> {
    return this.nextItem$;
  }

  override setItem(): void {
    throw new Error('Invalid access setItem');
  }

  override get keyItem$(): Observable<Item> {
    throw new Error('Invalid access keyItem$');
  }
}

@Component({
  selector: 'app-save-close-child-item',
  templateUrl: '../common-action-template.html',
  styleUrls: ['./save-close-child-item.component.scss']
})
export class SaveCloseChildItemComponent extends PrimeNGButtonSaveCloseItemActionComponent {
  constructor(
    @Optional() protected override window: ViewWindow,
    itemProvider: ItemProvider,
    itemViewProvider: ItemViewProviderDirective<ItemView>,
    formService: DynamicFormService,
    notificationService: NotificationService,
    backendUploadService: BackendUploadService,
    @Optional() parentItemProvider: ParentItemProviderService
  ) {
    super(
      window,
      new ChildItemProviderWrapper(itemProvider, parentItemProvider),
      itemViewProvider,
      formService,
      notificationService,
      backendUploadService
    );
  }
  protected override doExecuteWithItem(item: Item) {
    const files = (item as any)[NtapGlobalConstants.ATTR_FILE_UPLOAD];
    if (files?.length == 1) {
      const filename = files[0].name;
      (item as any)['$filename'] = filename;
    }
    return super.doExecuteWithItem(item);
  }
}
